module.exports = __webpack_public_path__ + "img/c.480f2efb.jpg";